import type { Dict } from '../index.js';

/** Arabic: shared label maps (statuses, types, classes) from packages/shared. Keys are the exact English text. */
export const labels: Dict = {
  // PUNCH_SOURCE_LABELS
  App: 'التطبيق',
  'Door QR': 'رمز QR على الباب',
  Fingerprint: 'البصمة',
  Imported: 'مستورد',
  'Added by admin': 'أضافه مسؤول النظام',
  'Desktop agent': 'برنامج سطح المكتب',
  // ATTENDANCE_STATUS_LABELS
  Present: 'حاضر',
  Absent: 'غائب',
  'On leave': 'في إجازة',
  'Public holiday': 'عطلة رسمية',
  'Day off': 'يوم عطلة',
  'Missing punch': 'تسجيل ناقص',
  Working: 'يعمل الآن',
  'Not yet in': 'لم يحضر بعد',
  'Not employed': 'غير موظَّف',
  'Not tracked': 'غير متتبَّع',
  '—': '—',
  // EMPLOYMENT_TYPE_LABELS
  'Full-time': 'دوام كامل',
  'Part-time': 'دوام جزئي',
  Contractor: 'متعاقد',
  Intern: 'متدرّب',
  Temporary: 'مؤقت',
  // EMPLOYMENT_STATUS_LABELS
  Active: 'نشط',
  Probation: 'فترة التجربة',
  Suspended: 'موقوف',
  Terminated: 'منتهية خدمته',
  // WORK_ARRANGEMENT_LABELS
  Office: 'في المكتب',
  Remote: 'عن بُعد',
  Hybrid: 'هجين',
  // WEEKDAY_LABELS
  Monday: 'الاثنين',
  Tuesday: 'الثلاثاء',
  Wednesday: 'الأربعاء',
  Thursday: 'الخميس',
  Friday: 'الجمعة',
  Saturday: 'السبت',
  Sunday: 'الأحد',
  // LEDGER_KIND_LABELS
  'Yearly entitlement': 'الاستحقاق السنوي',
  'Allowance changed': 'تغيير الاستحقاق',
  'Carried over': 'مُرحَّل',
  'Manual adjustment': 'تعديل يدوي',
  'Leave taken': 'إجازة مأخوذة',
  'Leave returned': 'إجازة مُعادة',
  // LEAVE_STATUS_LABELS
  Pending: 'قيد الانتظار',
  Approved: 'تمت الموافقة',
  Rejected: 'مرفوض',
  Cancelled: 'ملغى',
  // CLASS_LABELS
  Productive: 'منتج',
  Unproductive: 'غير منتج',
  Neutral: 'محايد',
  'Not classified': 'غير مصنَّف',
  Idle: 'خامل',
};
